import { CashbackBonusType } from 'config/types/bonus/userBonus'

import Column from 'layout/Components/Column'
import { RowBetween } from 'layout/Components/Row'
import { Trans, useTranslation } from 'react-i18next'
import { useCashbackBonus } from 'state/bonus/hooks/cashbackBonus'
import colors from 'theme/ui/colors'
import Box from 'UIKit/Box/Box'
import Flex from 'UIKit/Box/Flex'
import { FlexProps } from 'UIKit/Box/types'
import Image from 'UIKit/Image'
import Text from 'UIKit/Text'
import { useDisplayBonusName, useValidateBonus, ValidatedBonusStatusEnums } from 'views/BonusCenter/hooks'

const ContentLayout: React.FC<
  {
    bonus: CashbackBonusType
    activeContent?: React.ReactNode
    inactiveContent?: React.ReactNode
  } & FlexProps
> = ({ bonus, activeContent, inactiveContent, ...props }) => {
  const { t } = useTranslation()
  const { activeBonus, activeBonusInCashbackDuration } = useCashbackBonus()
  const validatedResult: ValidatedBonusStatusEnums = useValidateBonus(bonus)
  const bonusIsCompleted =
    bonus.isClaimable ||
    validatedResult === ValidatedBonusStatusEnums.Claimed ||
    validatedResult === ValidatedBonusStatusEnums.Finish ||
    validatedResult === ValidatedBonusStatusEnums.Expired

  const bonusIsActivated = bonus.id === activeBonus?.id && activeBonusInCashbackDuration

  const [name] = useDisplayBonusName(bonus.info.name)
  const bonusName =
    name || t('{{bonusCashbackRatePercent}}% Cashback Bonus', { bonusCashbackRatePercent: bonus.cashbackRate })

  return (
    <Column maxWidth="100%" {...props}>
      <RowBetween alignItems="center">
        <Flex alignItems="center" width="100%" style={{ gap: '12px' }}>
          <Image src={bonus.info.image} width={32} height={32} alt="logo" />
          <Text fontSize="14px" fontWeight={600} letterSpacing={-0.28}>
            {bonusName}
          </Text>
        </Flex>
        <Box background={colors.backgroundAlt5} padding="4px" borderRadius={'53px'}>
          <Text
            color={[bonusIsActivated, bonusIsCompleted].includes(true) ? 'success' : 'error'}
            fontWeight={700}
            fontSize="12px"
          >
            <Trans>
              {bonusIsActivated
                ? 'Active'
                : bonusIsCompleted
                ? 'Completed'
                : validatedResult === ValidatedBonusStatusEnums.Cancelled
                ? 'Cancelled'
                : ''}
            </Trans>
          </Text>
        </Box>
      </RowBetween>
      {bonusIsActivated ? activeContent : inactiveContent || null}
    </Column>
  )
}

export default ContentLayout
